// @flow
// Export config from base.html. Might later add other stuff here.

const baseConfig = window.BASE_CONFIG || ({}: any);

const config = {
  ...baseConfig,
};

export default config;
